export enum OperationPDRAEnum {
    PDRA_UNKNOWN = 'PDRA_UNKNOWN',
    PDRA_S_01 = 'PDRA_S_01',
    PDRA_S_02 = 'PDRA_S_02',
    PDRA_G_01 = 'PDRA_G_01',
    PDRA_G_02 = 'PDRA_G_02',
    PDRA_G_03 = 'PDRA_G_03',
}